import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ListApproved = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M15 12H5C4.448 12 4 11.552 4 11C4 10.448 4.448 10 5 10H15C15.552 10 16 10.448 16 11C16 11.552 15.552 12 15 12Z" />
		<path d="M14.125 28C13.057 28 12.052 27.584 11.297 26.828L7.297 22.828C6.541 22.072 6.125 21.068 6.125 20C6.125 17.794 7.919 16 10.125 16C11.193 16 12.198 16.416 12.953 17.172L14.125 18.344L21.297 11.172C22.053 10.417 23.057 10.001 24.125 10.001C26.331 10.001 28.125 11.795 28.125 14.001C28.125 15.069 27.709 16.074 26.953 16.829L16.953 26.829C16.197 27.585 15.193 28 14.124 28H14.125ZM10.125 18C9.022 18 8.125 18.897 8.125 20C8.125 20.534 8.333 21.036 8.711 21.414L12.711 25.414C13.089 25.792 13.591 26 14.125 26C14.659 26 15.162 25.792 15.539 25.414L25.539 15.414C25.917 15.036 26.125 14.534 26.125 14C26.125 12.897 25.228 12 24.125 12C23.591 12 23.089 12.208 22.711 12.586L14.832 20.465C14.442 20.855 13.808 20.855 13.418 20.465L11.539 18.586C11.161 18.208 10.659 18 10.125 18V18Z" />
		<path d="M27 6H5C4.448 6 4 5.552 4 5C4 4.448 4.448 4 5 4H27C27.552 4 28 4.448 28 5C28 5.552 27.552 6 27 6Z" />
	</svg>
);

export default ListApproved;
